export default {
      id: "twitter-usage",
      viewBox: "0 0 48 48",
      url: "/assets/" + "icons.svg#twitter",
      toString: function () {
        return this.url;
      }
    }